import React, { useState, useEffect } from "react";
import { FaAirbnb, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { HiOutlineBadgeCheck } from "react-icons/hi";
import "./Home.css";

const HouseOfTao = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    countryCode: "+91",
    mobile: "",
  });

  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (formData.mobile.length !== 10) {
      alert("Mobile number must be exactly 10 digits.");
      return;
    }

    const mergedData = {
      full_name: formData.full_name,
      email: formData.email,
      //   mobile: `${formData.countryCode}` + `${formData.mobile}`,
      mobile: formData.countryCode + formData.mobile,
    };

    const response = await fetch(
      "https://sohamvillas.com/web-backend/subscribetao",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(mergedData),
      }
    );

    const result = await response.text();
    alert(result);

    setIsSubscribed(true);

    setTimeout(() => {
      setIsSubscribed(false);
    }, 50000);

    setFormData({ full_name: "", email: "", mobile: "" });
  };

  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    document.body.style.overflow = showOverlay ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [showOverlay]);

  const countryCodes = [
    { name: "India", code: "+91" },
    { name: "Afghanistan", code: "+93" },
    { name: "Albania", code: "+355" },
    { name: "Algeria", code: "+213" },
    { name: "Andorra", code: "+376" },
    { name: "Angola", code: "+244" },
    { name: "Antigua and Barbuda", code: "+1-268" },
    { name: "Argentina", code: "+54" },
    { name: "Armenia", code: "+374" },
    { name: "Australia", code: "+61" },
    { name: "Austria", code: "+43" },
    { name: "Azerbaijan", code: "+994" },
    { name: "Bahamas", code: "+1-242" },
    { name: "Bahrain", code: "+973" },
    { name: "Bangladesh", code: "+880" },
    { name: "Barbados", code: "+1-246" },
    { name: "Belarus", code: "+375" },
    { name: "Belgium", code: "+32" },
    { name: "Belize", code: "+501" },
    { name: "Benin", code: "+229" },
    { name: "Bhutan", code: "+975" },
    { name: "Bolivia", code: "+591" },
    { name: "Bosnia and Herzegovina", code: "+387" },
    { name: "Botswana", code: "+267" },
    { name: "Brazil", code: "+55" },
    { name: "Brunei", code: "+673" },
    { name: "Bulgaria", code: "+359" },
    { name: "Burkina Faso", code: "+226" },
    { name: "Burundi", code: "+257" },
    { name: "Cabo Verde", code: "+238" },
    { name: "Cambodia", code: "+855" },
    { name: "Cameroon", code: "+237" },
    { name: "Canada", code: "+1" },
    { name: "Central African Republic", code: "+236" },
    { name: "Chad", code: "+235" },
    { name: "Chile", code: "+56" },
    { name: "China", code: "+86" },
    { name: "Colombia", code: "+57" },
    { name: "Comoros", code: "+269" },
    { name: "Congo (Brazzaville)", code: "+242" },
    { name: "Congo (Kinshasa)", code: "+243" },
    { name: "Costa Rica", code: "+506" },
    { name: "Croatia", code: "+385" },
    { name: "Cuba", code: "+53" },
    { name: "Cyprus", code: "+357" },
    { name: "Czech Republic", code: "+420" },
    { name: "Denmark", code: "+45" },
    { name: "Djibouti", code: "+253" },
    { name: "Dominica", code: "+1-767" },
    { name: "Dominican Republic", code: "+1-809" },
    { name: "Ecuador", code: "+593" },
    { name: "Egypt", code: "+20" },
    { name: "El Salvador", code: "+503" },
    { name: "Equatorial Guinea", code: "+240" },
    { name: "Eritrea", code: "+291" },
    { name: "Estonia", code: "+372" },
    { name: "Eswatini", code: "+268" },
    { name: "Ethiopia", code: "+251" },
    { name: "Fiji", code: "+679" },
    { name: "Finland", code: "+358" },
    { name: "France", code: "+33" },
    { name: "Gabon", code: "+241" },
    { name: "Gambia", code: "+220" },
    { name: "Georgia", code: "+995" },
    { name: "Germany", code: "+49" },
    { name: "Ghana", code: "+233" },
    { name: "Greece", code: "+30" },
    { name: "Grenada", code: "+1-473" },
    { name: "Guatemala", code: "+502" },
    { name: "Guinea", code: "+224" },
    { name: "Guinea-Bissau", code: "+245" },
    { name: "Guyana", code: "+592" },
    { name: "Haiti", code: "+509" },
    { name: "Honduras", code: "+504" },
    { name: "Hungary", code: "+36" },
    { name: "Iceland", code: "+354" },
    { name: "Indonesia", code: "+62" },
    { name: "Iran", code: "+98" },
    { name: "Iraq", code: "+964" },
    { name: "Ireland", code: "+353" },
    { name: "Israel", code: "+972" },
    { name: "Italy", code: "+39" },
    { name: "Jamaica", code: "+1-876" },
    { name: "Japan", code: "+81" },
    { name: "Jordan", code: "+962" },
    { name: "Kazakhstan", code: "+7" },
    { name: "Kenya", code: "+254" },
    { name: "Kiribati", code: "+686" },
    { name: "Kuwait", code: "+965" },
    { name: "Kyrgyzstan", code: "+996" },
    { name: "Laos", code: "+856" },
    { name: "Latvia", code: "+371" },
    { name: "Lebanon", code: "+961" },
    { name: "Lesotho", code: "+266" },
    { name: "Liberia", code: "+231" },
    { name: "Libya", code: "+218" },
    { name: "Liechtenstein", code: "+423" },
    { name: "Lithuania", code: "+370" },
    { name: "Luxembourg", code: "+352" },
    { name: "Madagascar", code: "+261" },
    { name: "Malawi", code: "+265" },
    { name: "Malaysia", code: "+60" },
    { name: "Maldives", code: "+960" },
    { name: "Mali", code: "+223" },
    { name: "Malta", code: "+356" },
    { name: "Marshall Islands", code: "+692" },
    { name: "Mauritania", code: "+222" },
    { name: "Mauritius", code: "+230" },
    { name: "Mexico", code: "+52" },
    { name: "Micronesia", code: "+691" },
    { name: "Moldova", code: "+373" },
    { name: "Monaco", code: "+377" },
    { name: "Mongolia", code: "+976" },
    { name: "Montenegro", code: "+382" },
    { name: "Morocco", code: "+212" },
    { name: "Mozambique", code: "+258" },
    { name: "Myanmar", code: "+95" },
    { name: "Namibia", code: "+264" },
    { name: "Nauru", code: "+674" },
    { name: "Nepal", code: "+977" },
    { name: "Netherlands", code: "+31" },
    { name: "New Zealand", code: "+64" },
    { name: "Nicaragua", code: "+505" },
    { name: "Niger", code: "+227" },
    { name: "Nigeria", code: "+234" },
    { name: "North Korea", code: "+850" },
    { name: "North Macedonia", code: "+389" },
    { name: "Norway", code: "+47" },
    { name: "Oman", code: "+968" },
    { name: "Pakistan", code: "+92" },
    { name: "Palau", code: "+680" },
    { name: "Palestine", code: "+970" },
    { name: "Panama", code: "+507" },
    { name: "Papua New Guinea", code: "+675" },
    { name: "Paraguay", code: "+595" },
    { name: "Peru", code: "+51" },
    { name: "Philippines", code: "+63" },
    { name: "Poland", code: "+48" },
    { name: "Portugal", code: "+351" },
    { name: "Qatar", code: "+974" },
    { name: "Romania", code: "+40" },
    { name: "Russia", code: "+7" },
    { name: "Rwanda", code: "+250" },
    { name: "Saint Kitts and Nevis", code: "+1-869" },
    { name: "Saint Lucia", code: "+1-758" },
    { name: "Saint Vincent and the Grenadines", code: "+1-784" },
    { name: "Samoa", code: "+685" },
    { name: "San Marino", code: "+378" },
    { name: "Sao Tome and Principe", code: "+239" },
    { name: "Saudi Arabia", code: "+966" },
    { name: "Senegal", code: "+221" },
    { name: "Serbia", code: "+381" },
    { name: "Seychelles", code: "+248" },
    { name: "Sierra Leone", code: "+232" },
    { name: "Singapore", code: "+65" },
    { name: "Slovakia", code: "+421" },
    { name: "Slovenia", code: "+386" },
    { name: "Solomon Islands", code: "+677" },
    { name: "Somalia", code: "+252" },
    { name: "South Africa", code: "+27" },
    { name: "South Korea", code: "+82" },
    { name: "South Sudan", code: "+211" },
    { name: "Spain", code: "+34" },
    { name: "Sri Lanka", code: "+94" },
    { name: "Sudan", code: "+249" },
    { name: "Suriname", code: "+597" },
    { name: "Sweden", code: "+46" },
    { name: "Switzerland", code: "+41" },
    { name: "Syria", code: "+963" },
    { name: "Taiwan", code: "+886" },
    { name: "Tajikistan", code: "+992" },
    { name: "Tanzania", code: "+255" },
    { name: "Thailand", code: "+66" },
    { name: "Timor-Leste", code: "+670" },
    { name: "Togo", code: "+228" },
    { name: "Tonga", code: "+676" },
    { name: "Trinidad and Tobago", code: "+1-868" },
    { name: "Tunisia", code: "+216" },
    { name: "Turkey", code: "+90" },
    { name: "Turkmenistan", code: "+993" },
    { name: "Tuvalu", code: "+688" },
    { name: "Uganda", code: "+256" },
    { name: "Ukraine", code: "+380" },
    { name: "United Arab Emirates", code: "+971" },
    { name: "United Kingdom", code: "+44" },
    { name: "United States", code: "+1" },
    { name: "Uruguay", code: "+598" },
    { name: "Uzbekistan", code: "+998" },
    { name: "Vanuatu", code: "+678" },
    { name: "Vatican City", code: "+379" },
    { name: "Venezuela", code: "+58" },
    { name: "Vietnam", code: "+84" },
    { name: "Yemen", code: "+967" },
    { name: "Zambia", code: "+260" },
    { name: "Zimbabwe", code: "+263" },
  ];

  // const [showFullText, setShowFullText] = useState(false);

  // const toggleReadMore = () => setShowFullText(!showFullText);

  return (
    <div className="font_Mont relative w-screen h-screen overflow-hidden">
      {/* <div className="lg:hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="../assets/Tao_portrait.webm" type="video/webm" />
        </video>
      </div> */}
      <div className="">
        {/* <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="../assets/Tao_landscape.webm" type="video/webm" />
        </video> */}

        <img
          src="../assets/Tao_background.webp"
          alt="Banner-Img"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      <div className="fontPOP_Light absolute inset-0 z-20 bg-black bg-opacity-0 flex justify-center">
        <div className="text-white p-5 w-full max-w-[900px] my-10">
          <p
            className="hidden sm:block text-center text-sm"
            style={{ letterSpacing: "20px", wordSpacing: "50px" }}
          >
            HOUSE OF TAO
          </p>

          <p
            className="sm:hidden text-center text-sm"
            style={{ letterSpacing: "10px", wordSpacing: "20px" }}
          >
            HOUSE OF TAO
          </p>

          <div className="grid grid-cols-2 gap-5 -ml-20 mt-[30vh] lg:mt-[50vh]">
            <p className="font-bold text-right">
              Booking are <br />
              Now Open!
            </p>

            <p className="text-sm mt-12">
              Our doors are now open for a limited launch season. <br />
              You can now reserve your stay.
            </p>
          </div>

          <button
            className="flex mx-auto text-xs text-center mt-[10vh] hover:underline underline-offset-4"
            style={{ letterSpacing: "5px", wordSpacing: "20px" }}
            onClick={() => setShowOverlay(true)}
          >
            LEARN MORE
          </button>
        </div>
      </div>

      <div className="fixed bottom-5 left-5 z-50">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width="60"
          height="60"
          // fill="white"
          fill={showOverlay ? "#beb6a3" : "white"}
        >
          <path d="M200 450 L80 510 V250 A80 80 0 0 1 200 170 Z" />
          <path d="M210 440 L330 380 V180 A80 80 0 0 0 210 100 Z" />
        </svg>
      </div>

      <div className="fixed bottom-5 right-5 z-50">
        <div className="flex gap-2 items-center">
          <a
            href="https://airbnb.co.in/h/houseoftao"
            target="_blank"
            rel="noopener noreferrer"
            className="group scale-90 w-11 hover:w-32 h-10 hover:bg-transparent relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
          >
            <FaAirbnb
              className={`w-7 h-7 shrink-0 fill-white group-hover:fill-pink-600  ${
                showOverlay ? "fill-[#97928c]" : "fill-white"
              }`}
            />
            <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
              Airbnb
            </span>
          </a>

          <a
            href="https://wa.me/918490984907"
            target="_blank"
            rel="noopener noreferrer"
            className="group scale-90 w-11 hover:w-32 h-10 hover:bg-transparent relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
          >
            <FaWhatsapp
              className={`w-7 h-7 shrink-0 fill-white group-hover:fill-green-600 ${
                showOverlay ? "fill-[#97928c]" : "fill-white"
              }`}
            />
            <span className="origin-left text-green-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-green-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
              WhatsApp
            </span>
          </a>

          <a
            href="https://www.instagram.com/houseoftao.goa"
            target="_blank"
            rel="noopener noreferrer"
            className="group scale-90 w-11 hover:w-32 h-10 relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
          >
            <FaInstagram
              className={`w-7 h-7 shrink-0 text-white group-hover:text-pink-600 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text ${
                showOverlay ? "text-[#97928c]" : "text-white"
              }`}
            />
            <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
              Instagram
            </span>
          </a>
        </div>
      </div>

      {/* <div className="fixed top-5 right-8 z-40">
        <input
          type="checkbox"
          id="overlayCheckbox"
          checked={showOverlay}
          onChange={() => setShowOverlay(!showOverlay)}
          className="hidden"
        />
        <label
          htmlFor="overlayCheckbox"
          className="toggle w-10 h-10 cursor-pointer flex flex-col items-center justify-center gap-2 transition-all duration-500"
        >
          <div
            className="bars w-[70%] h-1 bg-[#BFB5A3] rounded"
            id="bar1"
          ></div>
          <div
            className="bars w-full h-1 bg-[#BFB5A3] rounded transition-all duration-700"
            id="bar2"
          ></div>
          <div
            className="bars w-[70%] h-1 bg-[#BFB5A3] rounded"
            id="bar3"
          ></div>
        </label>
      </div> */}

      {showOverlay && (
        <div className="fontPOP_Light absolute inset-0 z-30 bg-[#e8e5de] flex justify-center">
          <div className="text-[#97928c] p-5 w-full max-w-[900px] my-10">
            <p
              className="hidden sm:block text-center text-sm"
              style={{ letterSpacing: "20px", wordSpacing: "50px" }}
            >
              HOUSE OF TAO
            </p>

            <p
              className="sm:hidden text-center text-sm"
              style={{ letterSpacing: "10px", wordSpacing: "20px" }}
            >
              HOUSE OF TAO
            </p>

            <div className="max-h-[65vh] overflow-y-auto mt-10 sm:mt-20">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:-ml-20">
                <p className="font-bold text-center md:text-right">
                  A New Way to <br />
                  Experience Stillness
                </p>

                <div className="text-sm md:mt-10 text-center md:text-left">
                  <p className="mt-4">
                    At House of Tão, hospitality is not just about where you
                    stay-it's about how you feel
                  </p>

                  <p className="mt-4 text-center md:text-left">
                    We believe in the quiet power of presence. In spaces that
                    slow you down. And in experiences that help you reconnect
                    with yourself, with others, and with the natural rhythm
                    around you,
                  </p>

                  <p className="mt-4">
                    -Vimal & Parth, your hosts at House of Tao
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:-ml-20 mt-5 md:mt-16">
                <p className="font-bold text-center md:text-right">
                  Be the First <br />
                  to Know
                </p>

                <p className="text-sm md:mt-10 text-center md:text-left">
                  Our doors are now open for a limited launch season. <br />
                  You can now reserve your stay.
                </p>
              </div>
            </div>

            <form className="mt-10" onSubmit={handleSubscribe}>
              <div className="grid grid-cols-2 justify-between gap-5">
                <input
                  type="text"
                  name="full_name"
                  required
                  value={formData.full_name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      full_name: e.target.value,
                    })
                  }
                  placeholder="name"
                  className="w-full bg-transparent focus:ring-0 focus:outline-none placeholder:text-[#97928c] text-[#2a2524] border border-b-[#beb6a3]"
                />

                <div className="flex gap-1">
                  <select
                    name="countryCode"
                    value={formData.countryCode}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        countryCode: e.target.value,
                      })
                    }
                    className="max-w-24 bg-transparent focus:ring-0 focus:outline-none placeholder:text-[#beb6a3] border border-b-[#beb6a3]"
                    style={{ appearance: "none" }}
                  >
                    {countryCodes.map((country) => (
                      <option
                        key={country.code + country.name}
                        value={country.code}
                      >
                        {`(${country.code}) ${country.name} `}
                      </option>
                    ))}
                  </select>

                  <input
                    type="text"
                    name="mobile"
                    required
                    value={formData.mobile}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d{0,10}$/.test(input)) {
                        setFormData({ ...formData, mobile: input });
                      }
                    }}
                    placeholder="mobile no."
                    className="w-full bg-transparent focus:ring-0 focus:outline-none placeholder:text-[#97928c] text-[#2a2524] border border-b-[#beb6a3]"
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2 mt-3">
                <input
                  type="text"
                  name="email"
                  required
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  placeholder="example@gmail.com"
                  className="w-full bg-transparent focus:ring-0 focus:outline-none placeholder:text-[#97928c] text-[#2a2524] border border-b-[#beb6a3]"
                />

                <button
                  type="submit"
                  disabled={isSubscribed}
                  className="hover:text-[#2a2524] border border-b-[#beb6a3]"
                >
                  {isSubscribed ? (
                    <div className="flex gap-1 items-center">
                      Subscribed <HiOutlineBadgeCheck size={20} />
                    </div>
                  ) : (
                    "Connect"
                  )}
                </button>
              </div>
            </form>

            <button
              className="flex mx-auto text-xs text-center mt-[3vh] md:mt-[8vh] hover:underline underline-offset-4"
              style={{ letterSpacing: "5px", wordSpacing: "20px" }}
              onClick={() => setShowOverlay(false)}
            >
              Back
            </button>
          </div>

          {/* <div className="text-white rounded-xl p-5 w-full max-w-[900px] space-y-6"> */}
          {/* Head */}
          {/* <div className="grid grid-cols-1 md:grid-cols-[70%_25%] items-end justify-between gap-5">
              <div className="order-2 md:order-1">
                <h1
                  className="font_POP text-xl md:text-3xl text-[#BFB5A3] font-bold mb-2"
                  style={{ letterSpacing: "1px" }}
                >
                  A New Way to Experience Stillness
                </h1>
                <p className="font_POP font-bold text-gray-200 text-[16px] md:text-xl max-w-[500px]">
                  At House of Tāo, hospitality is not just about where you stay
                  — it's about how you feel.
                </p>
              </div>

              <div className="flex md:justify-end order-1 md:order-2">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1d18cc51-70fe-4f8c-0655-03308b2af800/public"
                  alt="Logo"
                  className="h-auto w-32 md:w-44"
                />
              </div>
            </div> */}

          {/* Scroll content */}
          {/* <div className="pt-2 pb-10 max-h-[55vh] md:max-h-[70vh] overflow-y-auto">
              <div>
                For small screens
                <div className="block md:hidden space-y-4 text-sm md:text-[16px]">
                  {!showFullText ? (
                    <p className="truncate_line">
                      We believe in the quiet power of presence. In spaces that
                      slow...{" "}
                      <button
                        onClick={toggleReadMore}
                        className="text-gray-400 italic font-bold"
                      >
                        read more
                      </button>
                    </p>
                  ) : (
                    <>
                      <p>
                        We believe in the quiet power of presence. In spaces
                        that slow you down. And in experiences that help you
                        reconnect — with yourself, with others, and with the
                        natural rhythm around you.
                      </p>
                      <p>
                        This is not just a villa. It’s a space shaped by
                        intention — where design holds silence, and calm becomes
                        a way of being.
                      </p>
                      <p className="italic text-right">
                        — Vimal & Parth, your hosts at House of Tāo
                        <button
                          onClick={toggleReadMore}
                          className="text-gray-400 italic font-bold"
                        >
                          &nbsp;&nbsp; ...read less
                        </button>
                      </p>
                    </>
                  )}
                </div>

                For md: screen and above
                <div className="hidden md:block space-y-5 text-sm md:text-[16px]">
                  <p>
                    We believe in the quiet power of presence. In spaces that
                    slow you down. And in experiences that help you reconnect —
                    with yourself, with others, and with the natural rhythm
                    around you.
                  </p>
                  <p>
                    This is not just a villa. It’s a space shaped by intention —
                    where design holds silence, and calm becomes a way of being.
                  </p>
                  <p className="italic text-right">
                    — Vimal & Parth, your hosts at House of Tāo
                  </p>
                </div>
              </div>

              Booking 
              <div className=" mt-4 md:mt-0">
                <h2 className="font_POP text-lg md:text-xl font-bold mb-2">
                  Bookings Now Open
                </h2>
                <p className="mb-4 text-sm md:text-[16px]">
                  Our doors are now open for a limited launch season. You can
                  now reserve your stay.
                </p>

                <div className="flex flex-col sm:flex-row sm:gap-4 gap-2">
                  <div className="flex items-center">
                    Book on&nbsp;:
                    <a
                      href="https://airbnb.co.in/h/houseoftao"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group scale-90 w-11 hover:w-36 h-10 hover:bg-transparent relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
                    >
                      <FaAirbnb className="w-7 h-7 shrink-0 fill-white group-hover:fill-pink-600" />
                      <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                        Airbnb
                      </span>
                    </a>
                  </div>

                  <div className="flex items-center">
                    Message on&nbsp;:
                    <a
                      href="https://wa.me/918490984907"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group scale-90 w-11 hover:w-36 h-10 hover:bg-transparent relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
                    >
                      <FaWhatsapp className="w-7 h-7 shrink-0 fill-white group-hover:fill-green-600" />
                      <span className="origin-left text-green-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-green-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                        WhatsApp
                      </span>
                    </a>
                  </div>

                  <div className="flex items-center">
                    Follow us on&nbsp;:
                    <a
                      href="https://www.instagram.com/houseoftao.goa"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group scale-90 w-11 hover:w-36 h-10 relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
                    >
                      <FaInstagram className="w-7 h-7 shrink-0 text-white group-hover:text-pink-600 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text" />
                      <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                        Instagram
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              Subscription 
              <div className="mt-6">
                <h2 className="text-lg md:text-xl font-semibold mb-2">
                  Be the First to Know
                </h2>
                <p className="mb-4 text-sm md:text-[16px]">
                  Join the House of Tāo circle and receive early updates on
                  bookings, curated experiences, and future retreats.
                </p>

                <form
                  className="grid grid-cols-1 md:grid-cols-4 items-end mt-5 py-5 px-2 gap-8 md:gap-4"
                  onSubmit={handleSubscribe}
                >
                  <div className="flex items-center text-sm">
                    <div className="relative w-full">
                      <input
                        type="text"
                        name="full_name"
                        required
                        value={formData.full_name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            full_name: e.target.value,
                          })
                        }
                        placeholder=" "
                        className="w-full text-sm border-b border-gray-300 py-1 focus:border-b-2 focus:border-[#BFB5A3] transition-colors focus:outline-none peer bg-inherit"
                      />
                      <label
                        htmlFor="full_name"
                        className={`absolute left-0 transition-all cursor-text text-gray-500 
                            ${
                              formData.full_name
                                ? "-top-4 text-xs text-[#BFB5A3]"
                                : "top-1 text-sm text-white"
                            } 
                            peer-focus:-top-4 peer-focus:text-xs peer-focus:text-[#BFB5A3]`}
                      >
                        Full Name
                      </label>
                    </div>
                  </div>

                  <div className="flex items-center text-sm">
                    <div className="relative w-full">
                      <input
                        type="text"
                        name="email"
                        required
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        placeholder=" "
                        className="w-full text-sm border-b border-gray-300 py-1 focus:border-b-2 focus:border-[#BFB5A3] transition-colors focus:outline-none peer bg-inherit"
                      />
                      <label
                        htmlFor="email"
                        className={`absolute left-0 transition-all cursor-text text-gray-500
                        ${
                          formData.email
                            ? "-top-4 text-xs text-[#BFB5A3]"
                            : "top-1 text-sm text-white"
                        }
                        peer-focus:-top-4 peer-focus:text-xs peer-focus:text-[#BFB5A3]`}
                      >
                        Email
                      </label>
                    </div>
                  </div>

                  <div className="flex items-center text-sm">
                    <div className="relative w-full flex items-center gap-2">
                      <select
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            countryCode: e.target.value,
                          })
                        }
                        className="bg-inherit w-20 rounded-none border-b border-gray-300 mt-[1px] py-1 pr-2 focus:border-b-2 focus:border-[#BFB5A3] outline-none transition-colors text-sm"
                        style={{ appearance: "none" }}
                      >
                        {countryCodes.map((country) => (
                          <option
                            key={country.code + country.name}
                            value={country.code}
                          >
                            {`(${country.code}) ${country.name} `}
                          </option>
                        ))}
                      </select>

                      <div className="relative w-full text-sm">
                        <input
                          type="text"
                          name="mobile"
                          required
                          value={formData.mobile}
                          onChange={(e) => {
                            const input = e.target.value;
                            if (/^\d{0,10}$/.test(input)) {
                              setFormData({ ...formData, mobile: input });
                            }
                          }}
                          placeholder=" "
                          className="w-full md:w-[125%] text-sm border-b border-gray-300 py-1 focus:border-b-2 focus:border-[#BFB5A3] transition-colors focus:outline-none peer bg-inherit"
                        />
                        <label
                          htmlFor="mobile"
                          className={`absolute left-0 transition-all cursor-text text-gray-500
                            ${
                              formData.mobile
                                ? "-top-4 text-xs text-[#BFB5A3]"
                                : "top-1 text-sm text-white"
                            }
                            peer-focus:-top-4 peer-focus:text-xs peer-focus:text-[#BFB5A3]`}
                        >
                          Contact No.
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="flex md:justify-end">
                    <button
                      className={`fancy ${isSubscribed ? "subscribed" : ""}`}
                      type="submit"
                      disabled={isSubscribed}
                    >
                      <span className="top-key"></span>
                      <span className="text">
                        {isSubscribed ? (
                          <div classNameName="flex gap-1 items-center">
                            Subscribed <HiOutlineBadgeCheck size={20} />
                          </div>
                        ) : (
                          "Connect"
                        )}
                      </span>
                      <span className="bottom-key-1"></span>
                      <span className="bottom-key-2"></span>
                    </button>
                  </div>
                </form>
              </div>
            </div> */}
          {/* </div> */}
        </div>
      )}
    </div>
  );
};

export default HouseOfTao;
